<template>
  <b-modal
    size="md"
    title="Vista Previa"
    id="modal-vista-previa-flash"
    ref="modalVistaPreviaFlash"
    @shown="active"
  >
    <b-row>
      <b-col cols="12" style="text-align:right; margin-bottom:20px;">
        <button @click="descargarPdf" class="btn btn-primary">Descargar PDF</button>
      </b-col>
    </b-row>
    <div id="toCanvas" ref="toCanvas">
      <b-row>
        <b-col cols="12">
          <p>INSTRUCCIONES:</p>
          <p v-html="data.instrucciones" style="white-space: normal;"></p>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <div class="flash-card-print">
            <div>
              <p style="white-space: normal; margin-top: 25%;">Mano</p>
            </div>
          </div>
        </b-col>
        <b-col cols="6">
          <div class="flash-card-print">
            <div>
              <p style="white-space: normal; margin-top: 25%;">Mapa</p>
            </div>
          </div>
        </b-col>
        <b-col cols="6">
          <div class="flash-card-print">
            <div>
              <p style="white-space: normal; margin-top: 25%;">Microescopio</p>
            </div>
          </div>
        </b-col>
        <b-col cols="6">
          <div class="flash-card-print">
            <div>
              <p style="white-space: normal; margin-top: 25%;">Saludo</p>
            </div>
          </div>
        </b-col>

        <b-col cols="6">
          <div class="flash-card-print">
            <div>
              <b-img class="img-flash-print" :src="$root.setUrlFile('cme-1573675525677.jpeg')"></b-img>
            </div>
          </div>
        </b-col>
        <b-col cols="6">
          <div class="flash-card-print">
            <div>
              <b-img class="img-flash-print" :src="$root.setUrlFile('cme-1573675525677.jpeg')"></b-img>
            </div>
          </div>
        </b-col>
        <b-col cols="6">
          <div class="flash-card-print">
            <div>
              <b-img class="img-flash-print" :src="$root.setUrlFile('cme-1560551724141.jpeg')"></b-img>
            </div>
          </div>
        </b-col>
        <b-col cols="6">
          <div class="flash-card-print">
            <div>
              <b-img class="img-flash-print" :src="$root.setUrlFile('cme-1560551724141.jpeg')"></b-img>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export default {
  name: "modal-vista-previa-flash",
  props: {
    contenido: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      data: this.contenido,
      testBlob: null,
    };
  },
  created() {},
  methods: {
    active() {
      console.log(this.data);
    },
    close() {
      this.$bvModal.hide("modal-vista-previa-flash");
    },
    descargarPdf() {
      //let element = document.querySelector("#toCanvas");
      let element = this.$refs['toCanvas'];
      html2canvas(element, {
        scrollX: 0,
        scrollY: 0,
        useCORS: true,
        proxy: 'https://cdnmecit.nyc3.digitaloceanspaces.com'
      })
        .then(canvas => {
          var imgData = canvas.toDataURL("image/jpeg",1.0);
          //console.log(imgData);
          //debugger;
          var pdf = new jsPDF("p", "mm", "a4");
          var width = pdf.internal.pageSize.getWidth() - 10;
          var height = pdf.internal.pageSize.getHeight() - 20;
          pdf.addImage(imgData, "JPEG", 5, 5, width, height);
          pdf.save("flash.pdf");
        })
        .catch(error => {
          console.log("Erorr descargando PDF", error);
        });
    }
  }
};
</script>

<style lang="css" scoped>
.flash-card-print {
  border: 1px dashed #aaaaaa;
  width: auto;
  height: 200px;
  padding: 10px 10px;
  border-radius: 7px;
  margin: 5px;
  text-align: center;
  position: relative;
  color: #000;
  font-weight: 600;
  font-size: 20px;
}
.img-flash-print {
  width: 100%;
  height: 175px;
}
</style>